export const compareStringsNoCase = (a: string, b: string): boolean => (a || '').toLowerCase() === (b || '').toLowerCase()

export const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1)
